
export const environment = {
  production: false,
  appVersion: 'v8.2.4',
  USERDATA_KEY: 'authf649fc9a5f55',
  // apiUrl: 'https://localhost:7035/api',
  apiUrl: 'https://dev-templatify-gateway-api.roommatik.com/api',
  filebaseUrl: 'https://dev-templatify-api.roommatik.com/static/admin/',
  authUrl: 'https://auth.roommatik.com',
  authRealm: 'roommatik',
  authClientId: 'dev-templatify',
  portalUrl: 'https://portal.roommatik.com',
};